import axios from "axios";

const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

export function resolveBackendUrl(configuredUrl, location = window.location) {
  const configured = configuredUrl?.trim();

  if (configured) {
    try {
      const url = new URL(configured);
      // A loopback URL embedded during a local build is unreachable from a
      // deployed browser or mobile WebView. Production serves /api through the
      // same origin, so use that origin instead.
      if (!LOOPBACK_HOSTS.has(location.hostname) && LOOPBACK_HOSTS.has(url.hostname)) {
        return location.origin;
      }
      return configured.replace(/\/$/, "");
    } catch {
      // Let relative URLs resolve against the page that served the frontend.
      return new URL(configured, location.origin).href.replace(/\/$/, "");
    }
  }

  // CRA's development server runs separately from FastAPI. Deployed builds
  // use the reverse-proxied /api endpoint on their own origin.
  if (LOOPBACK_HOSTS.has(location.hostname) && ["3000", "3001"].includes(location.port)) {
    return `${location.protocol}//${location.hostname}:8000`;
  }
  return location.origin;
}

const BACKEND_URL = resolveBackendUrl(process.env.REACT_APP_BACKEND_URL);
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !String(error.config?.url || "").startsWith("/auth/login") && !String(error.config?.url || "").startsWith("/auth/google")) {
      const token = localStorage.getItem("token");
      if (token && error.config?.headers?.Authorization === `Bearer ${token}`) {
        localStorage.removeItem("token");
        window.dispatchEvent(new Event("auth-session-ended"));
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
